import React from 'react';
import { StowagePlanProvider, useStowagePlanStore } from './StowagePlanContext';
import { StowageUIProvider, useStowageUIStore } from './StowageUIContext';
import { StowageTankPlanProvider, useStowageTankPlanStore } from './StowageTankPlanContext';
import { StowageLayoutProvider, useStowageLayoutStore } from './StowageLayoutContext';
import { ContextProps } from '../types/ContextProps';

export { useStowagePlanStore, useStowageUIStore, useStowageTankPlanStore, useStowageLayoutStore };

export const StowageProvider = ({ children }: ContextProps) => (
    <StowagePlanProvider>
        <StowageUIProvider>
            <StowageTankPlanProvider>
                <StowageLayoutProvider>{children}</StowageLayoutProvider>
            </StowageTankPlanProvider>
        </StowageUIProvider>
    </StowagePlanProvider>
);

/** @deprecated Use specific context hooks instead for better performance */
export const useStowageStore = () => ({
    ...useStowagePlanStore(),
    ...useStowageUIStore(),
    ...useStowageTankPlanStore(),
    ...useStowageLayoutStore(),
});
